import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Tooltip, Typography } from '@mui/material';

import type { LensCertification } from '~/types/leLens';

import { ownerFirstName } from './lensLibrary';

const certifiedOn = (at: string) => new Date(at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });

export default function LensCertificationTick({
  certification,
  size = 18,
  focusable = false,
}: {
  certification?: LensCertification;
  size?: number;
  focusable?: boolean;
}) {
  const badge = certification?.badge;
  if (badge?.kind !== 'certified') return null;
  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="body2">
            {ownerFirstName(badge.by)} · {certifiedOn(badge.at)}
          </Typography>
          {badge.note && <Typography variant="caption">{badge.note}</Typography>}
        </Box>
      }
    >
      <CheckCircleIcon
        {...(focusable ? { tabIndex: 0, role: 'img', 'aria-hidden': false as const } : {})}
        aria-label="Certified"
        color="success"
        sx={{ fontSize: size, ml: 0.75, verticalAlign: 'middle' }}
      />
    </Tooltip>
  );
}
